import React, { useState, useEffect } from 'react';
import { TextField } from '@rmwc/textfield';
import '@material/textfield/dist/mdc.textfield.css';
import '@material/floating-label/dist/mdc.floating-label.css';
import '@material/notched-outline/dist/mdc.notched-outline.css';
import '@material/line-ripple/dist/mdc.line-ripple.css';
import '@material/ripple/dist/mdc.ripple.css';
import '@rmwc/icon/icon.css';

import './style.scss'

function CoaTextField(props) {
    const {label, data, onChange } = props
    const [value, setValue] = useState(data);

    return (
        <div className={`coa-dialog-form`}>
            <TextField
                outlined
                className={'fullwidth form-item clone-experience'}
                label={label}
                value={value}
                onChange={(e) => { setValue(e.target.value); onChange(e.target.value) }}
                onBlur={(e) => { onChange(e.target.value) }}
            >
            </TextField>
        </div>
    )
}

export default CoaTextField;